import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { compose, branch, renderComponent } from 'recompose';

import { COLORS } from '../../../../constants/styles';
import Icon from '../../../Icon';
import { useToggleFlag } from '../../../../hocs/useToogleFlag';
import RemoveInvitationLinkPopup from '../RemoveInvitationLinkPopup';
import PatientControls from '../SubscriberBtns/PatientControls';
import styles from '../SubscriberBtns/styles.styl';

const InviteeBtns = ({ invitee }) => {
  const [opened, open, close] = useToggleFlag();
  return (
    <div className={styles.root}>
      <div className={styles.overlay} />
      <div className={styles.actions}>
        <button
          type="button"
          className={cn(styles.btn, styles.btnClose)}
          onClick={open}
        >
          <Icon name="close" style={{ stroke: COLORS.white, width: '14px' }} />
        </button>
        <If condition={opened}>
          <RemoveInvitationLinkPopup
            opened={opened}
            onClose={close}
            email={invitee.login}
          />
        </If>
      </div>
    </div>
  );
};

InviteeBtns.propTypes = {
  invitee: PropTypes.object,
};

const enhance = compose(
  branch(({ isProvider }) => !isProvider, renderComponent(PatientControls)),
);

export default enhance(InviteeBtns);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/InviteeBtns/index.jsx